import { Container } from "@mui/material";
import DataLoadingFailed from "@entrilia/shared/components/DataLoadingFailed";
import InlineLoader from "@entrilia/shared/components/inlineLoader/InlineLoader";
import useFetch from "@entrilia/shared/hooks/useFetch";
import { logError } from "@entrilia/shared/logging";
import adminApi from "../../../../api/adminApi";
import PortalPagesSettingsEditor from "./PortalPagesSettingsEditor";

const PortalPagesSettings = () => {
  const [settingsResp, settingsError] = useFetch(adminApi.getInvestorPortalSettings);
  const [widgetSettingsResp, widgetSettingsError] = useFetch(adminApi.getPortalWidgetSettings);

  const fetchError = settingsError ?? widgetSettingsError;
  if (fetchError) {
    logError(fetchError, "[PortalPagesSettings] fetch");
    return <DataLoadingFailed title="Failed to load settings" />;
  }

  if (!settingsResp || !widgetSettingsResp) {
    return <InlineLoader />;
  }

  const { enabledFeatures, enabledPreviewOnlyFeatures } = settingsResp.settings;

  return (
    <Container maxWidth="md" disableGutters>
      <PortalPagesSettingsEditor
        initialEnabledFeatures={enabledFeatures ?? []}
        initialEnabledPreviewOnlyFeatures={enabledPreviewOnlyFeatures ?? []}
        widgets={widgetSettingsResp.widgets}
      />
    </Container>
  );
};

export default PortalPagesSettings;
